const Counter = ({title,number}) => {
    return(
        <div
        className='flex flex-col w-full'>
            <p
            className='text-[42px] text-center text-[#F6F6F6]'>
                {number}
                <span
                className=''>
                +
                </span>
            </p>
            <p
            className='text-[#E3E3E3] text-center ps-20 -mt-[10px]'>
                {title}
            </p>
        </div>
    )
}
export default Counter